import { useInfrastructureWizard } from '@/stores/infrastructureWizard'
import { applicationInstallPlan } from '@/utils/applicationInstall'
import styles from './Infrastructure.module.css'

/**
 * When the application (ERP) can be installed. With no new environment (the RDS server and the DB server are both Existing) it can be
 * installed right away. With a new environment (either is Dedicated) it is installed after the steps listed. Read-only: it follows the
 * choices on the Infrastructure step (data/applicationInstall.ts holds the wording and the steps).
 */
export function ApplicationInstallNote() {
  const data = useInfrastructureWizard()
  if (!data.level) return null
  const plan = applicationInstallPlan(data)
  return (
    <div className={styles.infoBox} role="note" aria-label="When the application is installed" data-testid="application-install" data-timing={plan.timing}>
      <div>
        <strong>{plan.note}</strong>
        {plan.steps.length > 0 && (
          <ol style={{ margin: '8px 0 0', paddingLeft: 20 }}>
            {plan.steps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        )}
      </div>
    </div>
  )
}
